import type { FunctionComponent } from 'react';
import Modal from 'react-modal';
import { showSuccessToast } from '@fff-web/fff-ui-shared';
import toastText from '../../utils/toastText';
import CloseButton from '../commons/close-button';
import SwapConfirmation from '../commons/swap-confirmation';
import * as styles from './SwapConfirmationModal.module.css';

interface ShowConfirmationModalProps {
  closeAction: () => void;
  setShowConfirmationModal: (x: boolean) => void;
  setHasSwapped: (x: boolean) => void;
}

const SwapConfirmationModal: FunctionComponent<ShowConfirmationModalProps> = ({
  closeAction,
  setShowConfirmationModal,
  setHasSwapped,
}) => (
  <Modal
    isOpen
    overlayClassName={styles.modalOverlay}
    className={styles.modalWrapper}
    shouldCloseOnOverlayClick={false}
    onRequestClose={() => closeAction()}
  >
    <div className={styles.modalContainer}>
      <CloseButton onClick={() => closeAction()} />
      <SwapConfirmation
        setShowConfirmation={setShowConfirmationModal}
        setHasSwapped={setHasSwapped}
        toastOnSwapConfirmation={() =>
          showSuccessToast(toastText.success.TITLE, toastText.success.SUBTITLE)
        }
      />
    </div>
  </Modal>
);

export default SwapConfirmationModal;
